/**
 * Clamps a value between an upper and lower bound
 * @param value Value to clamp
 * @param min Minimum value
 * @param max Maximum value
 * @returns {number} Clamped value
 */
export const clamp = (value: number, min = 0, max = Infinity) =>
  Math.min(Math.max(value, min), max);
